var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29289 7.70711C0.902369 7.31658 0.902369 6.68342 1.29289 6.29289L7.29289 0.292894C7.68342 -0.0976312 8.31658 -0.0976312 8.70711 0.292894L14.7071 6.29289C15.0976 6.68342 15.0976 7.31658 14.7071 7.70711C14.3166 8.09763 13.6834 8.09763 13.2929 7.70711L9 3.41421L9 15C9 15.5523 8.55229 16 8 16C7.44772 16 7 15.5523 7 15L7 3.41421L2.70711 7.70711C2.31658 8.09763 1.68342 8.09763 1.29289 7.70711Z",
    fill: "currentColor"
  })));
}

export default SvgArrowUp;